import React, { useEffect, useState } from "react";

const previewFrame = {
  aspectRatio: "16 / 9",
  background: "#eef1f6",
  border: "2px solid #0a4380",
  borderRadius: "6px",
  maxWidth: "520px",
  overflow: "hidden",
  position: "relative",
  width: "100%",
};

function ThumbnailPreview({ file, src, alt = "Blog thumbnail preview" }) {
  const [objectUrl, setObjectUrl] = useState("");

  useEffect(() => {
    if (!(file instanceof File)) {
      setObjectUrl("");
      return undefined;
    }

    const nextUrl = URL.createObjectURL(file);
    setObjectUrl(nextUrl);
    return () => URL.revokeObjectURL(nextUrl);
  }, [file]);

  const previewSrc = objectUrl || src;
  if (!previewSrc) return null;

  return (
    <div className="mb-4">
      <div className="fw-bold mb-1">
        Thumbnail Preview
      </div>
      <div className="text-muted mb-2">
        This is how the centered crop will appear on the blog listing.
      </div>
      <div style={previewFrame}>
        <img
          src={previewSrc}
          alt={alt}
          style={{
            display: "block",
            height: "100%",
            objectFit: "cover",
            objectPosition: "center",
            width: "100%",
          }}
        />
        <span
          aria-hidden="true"
          style={{
            borderLeft: "1px dashed rgba(255,255,255,.72)",
            borderRight: "1px dashed rgba(255,255,255,.72)",
            bottom: 0,
            left: "33.333%",
            pointerEvents: "none",
            position: "absolute",
            right: "33.333%",
            top: 0,
          }}
        />
        <span
          aria-hidden="true"
          style={{
            borderBottom: "1px dashed rgba(255,255,255,.72)",
            borderTop: "1px dashed rgba(255,255,255,.72)",
            bottom: "33.333%",
            left: 0,
            pointerEvents: "none",
            position: "absolute",
            right: 0,
            top: "33.333%",
          }}
        />
        <span
          aria-hidden="true"
          style={{
            border: "1px solid rgba(255,255,255,.85)",
            bottom: "8px",
            boxShadow: "0 0 0 999px rgba(5, 23, 47, .08)",
            left: "8px",
            pointerEvents: "none",
            position: "absolute",
            right: "8px",
            top: "8px",
          }}
        />
      </div>
    </div>
  );
}

export default ThumbnailPreview;
